import { type FC, memo, useState } from 'react';

import { findRegionsByIds } from 'utils/campaign';

import useTrls from 'hooks/translation/useTrls';

import InfoRow from 'components/CampaignCard/CampaignInfo/Targetings/InfoRow/InfoRow';
import AdditionalRegionsModal from 'components/CampaignCard/CampaignInfo/Targetings/Regions/AdditionalRegionsModal';
import { WithAdditional } from 'components/CampaignCard/CampaignInfo/Targetings/utils';

import { selectRegions } from 'store/autoReducers';
import { useSelector } from 'store/utils';

interface Props {
    campaignAreas: {
        include: string[];
        exclude: string[];
    };
}

const AdIncludedRegions = WithAdditional(InfoRow);
const AdExcludedRegions = WithAdditional(InfoRow);

const Regions: FC<Props> = ({ campaignAreas }) => {
    const regions = useSelector(selectRegions);
    const [showModal, setShowModal] = useState(false);

    const trls = useTrls();

    if (campaignAreas.include.length === 0) {
        return null;
    }

    const includedRegions = findRegionsByIds(campaignAreas.include, regions, true);
    const excludedRegions = findRegionsByIds(campaignAreas.exclude, regions, true);

    return (
        <>
            <AdIncludedRegions
                onAdditionalTextClick={() => setShowModal(true)}
                titleTrl={trls('campaign.targetings.regions.include.item')}
                items={includedRegions}
            />

            {Boolean(excludedRegions.length) && (
                <AdExcludedRegions
                    onAdditionalTextClick={() => setShowModal(true)}
                    titleTrl={trls('campaign.targetings.regions.exclude.item')}
                    items={excludedRegions}
                />
            )}

            <AdditionalRegionsModal
                visible={showModal}
                setVisible={setShowModal}
                titleKey={'campaign.targetings.regions.modal.title'}
                areas={{ include: includedRegions, exclude: excludedRegions }}
                closeKey={'common.close'}
            />
        </>
    );
};

export default memo(Regions);
